import { render, staticRenderFns } from "./DocsUserManualChapter2.vue?vue&type=template&id=81ce8a16&scoped=true&"
var script = {}
import style0 from "./DocsUserManualChapter2.vue?vue&type=style&index=0&id=81ce8a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ce8a16",
  null
  
)

export default component.exports